import { render, staticRenderFns } from "./hotList.vue?vue&type=template&id=a3bc80f6&scoped=true&"
import script from "./hotList.vue?vue&type=script&lang=js&"
export * from "./hotList.vue?vue&type=script&lang=js&"
import style0 from "./hotList.vue?vue&type=style&index=0&id=a3bc80f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bc80f6",
  null
  
)

export default component.exports